export default "__VITE_PUBLIC_ASSET__68c9e4ae__"